import React, { useState, useEffect } from "react";
import ManageSchools from "./ManageSchools";
import ManageCourses from "./ManageCourses";
import ManageDepartments from "./ManageDepartments";

import ManagePrograms from "./ManagePrograms";
import ManageIndirectPOAttainments from "./ManageIndirectPOAttainments";
import "../../../../App.css";

const TAB_KEY = "manageInstituteSetupActiveTab";

const ManageInstituteSetup = () => {
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem(TAB_KEY) || "schools"
  );

  useEffect(() => {
    localStorage.setItem(TAB_KEY, activeTab);
  }, [activeTab]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "schools":
        return <ManageSchools />;
      case "departments":
        return <ManageDepartments />;
      case "programs":
        return <ManagePrograms />;
      case "indirect-po-attainments":
        return <ManageIndirectPOAttainments />;
      case "courses":
        return <ManageCourses />;
      default:
        return null;
    }
  };

  return (
    <div className="manage-academics-container">
      <div className="tabs">
        <button
          className={`tab-btn ${activeTab === "schools" ? "active" : ""}`}
          onClick={() => setActiveTab("schools")}
        >
          Schools
        </button>
        <button
          className={`tab-btn ${activeTab === "departments" ? "active" : ""}`}
          onClick={() => setActiveTab("departments")}
        >
          Departments
        </button>
        <button
          className={`tab-btn ${activeTab === "programs" ? "active" : ""}`}
          onClick={() => setActiveTab("programs")}
        >
          Programs
        </button>
         <button
          className={`tab-btn ${activeTab === "courses" ? "active" : ""}`}
          onClick={() => setActiveTab("courses")}
        >
          Courses
        </button>
        <button
          className={`tab-btn ${activeTab === "indirect-po-attainments" ? "active" : ""}`}
          onClick={() => setActiveTab("indirect-po-attainments")}
        >
          Indirect PO Attainment
        </button>
      </div>

      <div className="tab-content">{renderActiveTab()}</div>
    </div>
  );
};

export default ManageInstituteSetup;